import { Capacitor } from "@capacitor/core"
import webHttp from "./webHttp"
import { accessToken } from "./accessToken"
import { TokenVault } from "./TokenVault"

export const SessionService = {
  async login({ email, password }) {
    const response = await webHttp.post("/api/v1/auth", { email, password })
    if (Capacitor.isNativePlatform() && response.data.api_token) {
      await TokenVault.set(response.data.api_token)
    }
    accessToken.set(response.data.access_token)
  },

  async exchange() {
    const config = {}
    if (Capacitor.isNativePlatform()) {
      const token = await TokenVault.get()
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` }
      }
    }
    const response = await webHttp.get("/api/v1/auth", config)
    accessToken.set(response.data.access_token)
    return response.data.access_token
  },

  async fetchMe() {
    const config = {}
    if (Capacitor.isNativePlatform()) {
      const token = await TokenVault.get()
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` }
      }
    }
    const response = await webHttp.get("/api/v1/me", config)
    return response.data
  },

  async updateMe(fields) {
    const config = {}
    if (Capacitor.isNativePlatform()) {
      const token = await TokenVault.get()
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` }
      }
    }
    const response = await webHttp.patch("/api/v1/me", fields, config)
    return response.data
  },

  async deleteMe() {
    const config = {}
    if (Capacitor.isNativePlatform()) {
      const token = await TokenVault.get()
      if (token) {
        config.headers = { Authorization: `Bearer ${token}` }
      }
    }
    await webHttp.delete("/api/v1/me", config)
  },

  async logout() {
    try {
      const config = {}
      if (Capacitor.isNativePlatform()) {
        const token = await TokenVault.get()
        if (token) {
          config.headers = { Authorization: `Bearer ${token}` }
        }
      }
      await webHttp.delete("/api/v1/auth", config)
    } catch {
      // best-effort revoke - always clear local state regardless
    }
    await TokenVault.clear()
    accessToken.clear()
  },
}

export default SessionService
